import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { APPLICATION_PATHS, ENTITLEMENTS } from '../application-core/constants';
import DataManagerIcon from '../core/icons/DataManager';
import ProjectsManager from '../core/project/ProjectsManager';
import ProjectWrapper from '../core/project/ProjectWrapper';
import StandardAppBar from '../core/StandardAppBar';
import CreateDataProject from './dataproject/CreateDataProject';
import DataProject from './dataproject/DataProject';
import DataProjectsManager from './DataProjectsManager';

class DataApplication extends Component {

  render() {

    return (
      <React.Fragment>
        <Switch>
          <Route exact path={APPLICATION_PATHS.DATA_MANAGER} render={
            (props) => <ProjectsManager {...props}
              appBar={<StandardAppBar title="Data Manager" />}
              projectCreator={CreateDataProject}
              projectType="DataProject"
              lockedGraphs={this.props.lockedGraphs}
              entitlement={ENTITLEMENTS.CREATE_DATA_PROJECT}
              homeIcon={{
                name: "Data Manager Home",
                url: '',
                icon: <DataManagerIcon/>
              }}
              projectClass="https://grafsync.graphifi.com/schema/gs/DataProject"
              applicationTitle="Data Manager"
              applicationURL={APPLICATION_PATHS.DATA_MANAGER}
            />
          } />
          <Route path={APPLICATION_PATHS.DATA_MANAGER + "/project"} render={
            (props) => <ProjectWrapper {...props}
              component={DataProject}
              lockedGraphs={this.props.lockedGraphs}
              loadKey={this.props.loadKey}
              applicationTitle="Data Manager"
              applicationURL={APPLICATION_PATHS.DATA_MANAGER}
            />
          } />
          <Route path={APPLICATION_PATHS.DATA_MANAGER} render={
            (props) => <DataProjectsManager {...props}
              applicationTitle="Data Manager"
              applicationURL={APPLICATION_PATHS.DATA_MANAGER}
            />
          } />
        </Switch>
      </React.Fragment>
    );
  }
}

DataApplication.propTypes = {
  lockedGraphs: PropTypes.array,
  loadKey: PropTypes.string
};

export default DataApplication;